import React, { useState } from "react";
import { MdVisibility } from "react-icons/md";
import { toast } from "react-toastify";
import axiosInstance from "../Context/axiosInstance";
import ManageVisibilityModal from "./ManageVisibilityModal";

const getErrorMessage = (error) =>
  error.response?.data?.errors?.[0]?.reason ||
  error.response?.data?.detail ||
  error.response?.data?.message ||
  error.message ||
  "Could not update visibility.";

export default function ContentBulkVisibility({
  courseId,
  contentType,
  selectedIds,
  onSuccess,
}) {
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const count = selectedIds.length;
  const singular = contentType.endsWith("s")
    ? contentType.slice(0, -1)
    : contentType;

  const updateVisibility = async (hide) => {
    setSaving(true);
    try {
      await axiosInstance.post(
        `/courses/${courseId}/${contentType}/${hide ? "hide" : "unhide"}`,
        { ids: selectedIds },
      );
      toast.success(
        `${count === 1 ? singular : contentType} ${
          hide ? "hidden from" : "shown to"
        } students successfully.`,
      );
      setOpen(false);
      onSuccess?.(hide);
    } catch (error) {
      toast.error(getErrorMessage(error));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        disabled={count === 0}
        className={`flex items-center justify-center rounded-lg bg-slate-600 px-4 py-2 text-white transition-opacity lg:px-6 lg:py-3 ${
          count === 0
            ? "cursor-not-allowed opacity-40"
            : "hover:bg-slate-700"
        }`}
      >
        <MdVisibility size={25} className="pr-2" />
        Visibility
      </button>

      <ManageVisibilityModal
        open={open}
        count={count}
        itemLabel={count === 1 ? singular : contentType}
        onClose={() => setOpen(false)}
        onChange={updateVisibility}
        loading={saving}
      />
    </>
  );
}
